import { XCircle } from 'lucide-react';

interface ErrorStateProps {
    message?: string;
    onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
    return (
        <div className="rounded-lg bg-red-50 border border-red-200 p-4 md:p-8 text-center">
            <div className="flex justify-center mb-4">
                <div className="p-3 bg-red-100 rounded-full">
                    <XCircle className="h-6 w-6 md:h-8 md:w-8 text-red-600" />
                </div>
            </div>
            <h3 className="text-base md:text-lg font-semibold text-red-900 mb-2">Erro ao carregar dados</h3>
            <p className="text-xs md:text-sm text-red-700 mb-4">
                {message || 'Não foi possível carregar os dados. Tente novamente.'}
            </p>
            {onRetry && (
                <button
                    onClick={onRetry}
                    className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
                >
                    Tentar Novamente
                </button>
            )}
        </div>
    );
}